import type { AggregateOffer, UnitPriceSpecification } from 'apps/commerce/types.ts'

export const bestInstallment = (
    acc: UnitPriceSpecification | null,
    curr: UnitPriceSpecification,
) => {
    if (curr?.priceComponentType !== 'https://schema.org/Installment') {
        return acc
    }

    if (!acc) {
        return curr
    }

    if (acc.price > curr.price) {
        return curr
    }

    if (acc.price < curr.price) {
        return acc
    }

    if (acc.billingDuration && curr.billingDuration && acc.billingDuration < curr.billingDuration) {
        return curr
    }

    return acc
}

export function withTaxes(installment: UnitPriceSpecification, sellingPrice: number) {
    const { price } = installment
    const withTaxes = sellingPrice < price

    return withTaxes
}

const installmentToString = (installment: UnitPriceSpecification, sellingPrice: number) => {
    const { billingDuration, billingIncrement, price } = installment

    if (!billingDuration || !billingIncrement) {
        return ''
    }

    const withTaxes = sellingPrice < price

    return `${billingDuration}x de R$ ${billingIncrement} ${withTaxes ? 'com juros' : 'sem juros'}`
}

export const useOffer = (aggregateOffer?: AggregateOffer) => {
    const offer = aggregateOffer?.offers[0]
    const listPrice = offer?.priceSpecification.find(
        (spec) => spec.priceType === 'https://schema.org/ListPrice',
    )
    const installment = offer?.priceSpecification.reduce(bestInstallment, null)
    const seller = offer?.seller
    const price = offer?.price
    const availability = offer?.availability
    const installments = offer?.priceSpecification
    // Removed inventory level from all datalayer events, as it's not being used and are affecting google analytics data
    // const quantity = offer?.inventoryLevel?.value

    return {
        price,
        listPrice: listPrice?.price,
        availability,
        seller,
        formatedBestInstallment: installment && price
            ? installmentToString(installment, price)
            : null,
        bestInstallment: installment,
        installments,
        // quantity,
    }
}
